/*
* Helper for updating a partial view
* Can either update directly with a string/html, or from an URI
*/ 
module.exports = function (opt) {
    var $el = $(opt.$el),
        updateState = $.Deferred();

    //console.log(opt);

    if (opt.outerHtml) {
        replacePartialView(opt.outerHtml);
    }
    else {
        shop.request(opt.ajax).then(replacePartialView);
    }

    var loadingTimeout;
    if (!opt.outerHtml) {
        loadingTimeout = setTimeout(function () {
            $el.hLoading();
        }, 100);
    }

    function replacePartialView (outerHtml) {

        clearTimeout(loadingTimeout);

        var $newEl = $(outerHtml);

        // Replace DOM element
        $el.replaceWith($newEl);

        updateState.resolve($newEl);

        // Notify "the world" that the DOM has updated
        hLib.triggerDOMUpdated({
            $scope: $newEl,
            name: opt.domEventName
        });
    }

    return updateState;
};